import React from "react";
import { useStoreState } from "easy-peasy";
import { Redirect, Route } from "react-router-dom";
import PrivateLayout from "Pages/private/layout";

const PrivateLayoutRoute = ({ ...props }) => {
  const { valid } = useStoreState((state) => state.auth);

  return (
    <Route
      {...props}
      render={(matchProps) =>
        valid ? (
          <PrivateLayout />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: matchProps.location } }}
          />
        )
      }
    />
  );
};

export default PrivateLayoutRoute;
